import { z } from 'zod';

export const ReferralCodeStatusSchema = z.enum(['PENDING']);

export type ReferralCodeStatusType = `${z.infer<typeof ReferralCodeStatusSchema>}`

export default ReferralCodeStatusSchema;
